import React, { ReactNode } from 'react';

import IMAGES from '../../Constants/Images.constants';
import AppBanner from '../../Components/IllustrationBanner/IllustrationBanner.component';
import { LanguageSelector } from '~/Components';
import { CopyrightFooter } from '../../Components/CopyrightFooter';
import { makeStyles } from '~/UIKit/Style';

interface PublicLayoutProps {
  children: ReactNode;
}

export const PublicLayout = ({ children }: PublicLayoutProps) => {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <AppBanner className={classes.illustrationContainerHideOnSmallScreen} />
      <img className={classes.logo} src={IMAGES.FitogramProLogo} />
      <div className={classes.wrapper}>{children}</div>
      <LanguageSelector />
      <AppBanner className={classes.illustrationContainerHideOnLargeScreen} count={6} />
      <CopyrightFooter />
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    [theme.breakpoints.up('md')]: {
      height: '100vh',
    },
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  illustrationContainerHideOnLargeScreen: {
    marginTop: 30,
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  illustrationContainerHideOnSmallScreen: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  logo: {
    height: 'auto',
    width: 225,
    margin: '50px 0 30px 0',
  },
  footer: {
    [theme.breakpoints.up('md')]: {
      position: 'absolute',
    },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    bottom: 0,
  },
  footerText: {
    margin: theme.spacing(),
  },
  wrapper: {
    padding: '0 15px',
  },
}));

export default PublicLayout;
